export const TEXT_FIELD = 'TextField';
export const SELECT = 'Select';
export const DATE_PICKER = 'DatePicker';
export const SLIDER = 'Slider';
export const SWITCH = 'Switch';
